class Cart{
    constructor() {
        this.cart = document.querySelector('.woocommerce-cart');
        this.table = !this.cart || this.cart.querySelector('.shop_table');
        
        
        if(this.cart){
            this.products = !this.table || this.table.querySelector('tbody tr.cart_item') ? this.table.querySelectorAll('tbody tr.cart_item') : false;
            !this.products || this.products.forEach(el => this.quantiti(el));
    
            jQuery(document.body).on('updated_cart_totals', () => {
                !document.querySelector('tbody tr.cart_item') || document.querySelectorAll('tbody tr.cart_item').forEach(el => this.quantiti(el));
            });
        }
    }

    quantiti(el){
        let qu = el.querySelector('.product-quantity .quantity'),
            inp = qu.querySelector('input');
        
        if(qu){
            if(!qu.querySelector('button.minus') && !qu.querySelector('button.plus')){
                let button = document.querySelector('button[name=update_cart]'),
                    minus = document.createElement('button'),
                    plus = document.createElement('button');
    
                minus.classList.add('minus');
                minus.innerHTML = '-';
                plus.classList.add('plus');
                plus.innerHTML = '+';
    
                qu.prepend(minus);
                qu.append(plus);
    
    
                minus.addEventListener('click', e => {
                    e.preventDefault();
                    if(Number(inp.value) > 0){
                        inp.value = --inp.value;
                        button.disabled = false;
                        button.ariaDisabled = false;
                        button.click();
                    }
                })
    
                plus.addEventListener('click', e => {
                    e.preventDefault();
                    console.log(inp.value);
                    inp.value = ++inp.value;
                    button.disabled = false;
                    button.ariaDisabled = false;
                    button.click();
                })
            }
        }
    }
}

export default  Cart;